export const SORTING_MODE = {
    ASC: 'ASC',
    DESC: 'DESC',
    UNDEFINED: 'UNDEFINED'
} as const;
